<template>
  <div>
    <TriangleHeader :title="$t('contact_with_us')"/>
    <loading v-if="loading"/>
    <div v-else class="mt-16 d-flex flex-column justify-center align-center text-center w-60 ma-auto">
      <div>
        <h5 class="font-weight-bold mb-8">
          {{ $t('contact_us_description') }}
        </h5>
        <div v-if="formSent">
          <h6 style="color:green">{{$t('message_sent_successfully')}}</h6>
        </div>
        <v-form v-model="valid"
                ref="form"
                v-else
                lazy-validation>
          <v-row>
            <v-col  class="px-6 pb-1" v-for="(item,index) in form.data" :key="index"
                   :cols="$vuetify.breakpoint.width<961?12:6">

              <p dir="auto" class="font-weight-bold text-right px-2">
                {{ item ? item[`title_${$i18n.locale}`]:"" }}</p>
              <!--          Text Box-->
              <v-text-field :rules="item.required?[...textRules,...(item.id == 89 ? [rules.email]:[])]:''"
                            height="50"
                            v-if="item.type===0"
                            flat
                            dense
                            outlined
                            v-model="item.model"
              ></v-text-field>


            </v-col>
            <v-col cols="12" class="px-6 pb-1">
              <p dir="auto" class="font-weight-bold text-right px-2">
                {{ $t('message_text') }}
              </p>
              <v-textarea
                  :rules="textRules"
                  height="100"
                  rows="2"
                  flat
                  dense
                  outlined
                  v-model="content"
              />
            </v-col>
          </v-row>

        </v-form>
        <div
            @click="sendForm"
            class="app-btn my-4 mr-6"
            :loading="btnLoading"
            v-if="!formSent"
        >
          <v-progress-circular
              size="30"
              width="4"
              color="white"
              indeterminate
              v-if="btnLoading"
          >

          </v-progress-circular>
          <p class="app-btn" v-else>{{ $t('send') }}</p>
        </div>

        <v-row class="text-center mt-8">
          <v-col class="text-center d-flex justify-center" cols="6" v-if="contactDetails.factory_phone">
            <div class="my-3">
              <v-img width="80" src="@/assets/icons/factory.svg"></v-img>
              <h5 class="font-weight-bold mt-4">{{ $t('factory') }}</h5>
              <a :href="`tel:${contactDetails.factory_phone}`" dir="auto" class="">{{contactDetails.factory_phone}}</a>
            </div>
          </v-col>
          <v-col class="text-center d-flex justify-center" cols="6" v-if="contactDetails.phone">
            <div class="my-3 ">
              <v-img width="80" src="@/assets/icons/office.svg"></v-img>
              <h5 class="font-weight-bold mt-4">{{ $t('central-office') }}</h5>
              <a :href="`tel:${contactDetails.phone}`" dir="auto" class="">{{contactDetails.phone}}</a>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-8">
          <v-col cols="4" class="text-center d-flex justify-center" v-if="contactDetails.china_phone">
            <div>
              <v-img width="62" src="@/assets/icons/china.svg"></v-img>
              <h5 class="font-weight-bold mt-4">{{ $t('china_office') }}</h5>
              <a :href="`tel:${contactDetails.china_phone}`" dir="auto">{{contactDetails.china_phone}}</a>
            </div>
          </v-col>
          <v-col cols="4" class="text-center d-flex justify-center" v-if="contactDetails.oman_phone">
            <div>
              <v-img width="62" src="@/assets/icons/oman.svg"></v-img>
              <h5 class="font-weight-bold mt-4">{{ $t('oman_Office') }}</h5>
              <a :href="`tel:${contactDetails.oman_phone}`" dir="auto">{{contactDetails.oman_phone}}</a>
            </div>
          </v-col>
          <v-col cols="4" class="text-center d-flex justify-center align-center" v-if="contactDetails.emirate_phone">
            <div>
              <v-img class="mr-12" width="62" src="@/assets/icons/united-arab-emirates.svg"></v-img>
              <h5 class="font-weight-bold mt-4">{{ $t('emirates') }}</h5>
              <a :href="`tel:${contactDetails.emirate_phone}`" dir="auto">{{contactDetails.emirate_phone}}</a>
            </div>
          </v-col>

        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import {GET_CONTACT_US, POST_CONTACT_US} from "../../../store/aboutManagement/action_type";
import {mapState} from "vuex";
import TriangleHeader from "../../../components/triangle_header/TriangleHeader";
import {SEND_FORM} from "../../../store/formManagement/action_types";

export default {
  name: "ContactUs",
  components: {TriangleHeader},
  data() {
    return {
      valid: false,
      formSent:false,
      btnLoading:false,
      isError: false,
      isSuccess: false,
      content: '',
      textRules: [
        v => !!v || 'پر کردن فیلد الزامی است',
      ],
      rules: {
          required: value => !!value || 'الزامی.',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'ایمیل نامعتبر.'
          },
        },
    }
  },
  created() {
    this.$store.dispatch(`aboutManagement/${GET_CONTACT_US}`)
  },
  computed: {
    ...mapState({
      form: state => state.aboutManagement.contactUsForm,
      loading: state => state.aboutManagement.loading,
      contactDetails: state => state.homeManagement.contactDetails,
      
    })
  },
  methods: {
    sendForm() {
      if (this.$refs.form.validate()) {
        try{
          this.btnLoading = true;
        var data = {};
        var key;

        for (let i = 0; i < Object.keys(this.form).length; i++) {
          let currentCategory = this.form[Object.keys(this.form)[i]];
          for (let j = 0; j < currentCategory.length; j++) {
            var item = currentCategory[j];

            // data[item.title_en] = item.model;
            data[`customField_${item.id}`] = item.model;
            

          }

        }
        data['details_en']=this.content;
        data['details_ar']=this.content;
        data['details_fa']=this.content;
        data.id = 11;
        data.api_key = '402784613679330';
        this.$store.dispatch(`aboutManagement/${POST_CONTACT_US}`, data).then(
            response => {
             try{
              this.btnLoading = false;
              this.formSent=true
              if (response) {
                this.isSuccess = true;
                
                
                setTimeout(() => {
                  this.loading = false;
                  this.$router.replace('/');
                }, 3000)
              } else {
                this.loading = false;
                this.isError = true;
              }
             }catch(e){
              console.log("error occurred",e)
             }
              
            }
        );
        }catch(e){
          console.log("error",e)
        }
      }
    },
  }
}
</script>

<style scoped>

</style>